export type M1Level =
  | "M1-0"   // Korean HQ Operator
  | "M1-1"   // Vietnam HQ (Bizwell VN)
  | "M1-01"  // Korean Admin
  | "M1-11"  // Vietnam Admin
  | "M1-02"  // Korean Admin Level 2
  | "M1-12"  // Vietnam Admin Level 2
  | "M1-employee"; // Regular employee

export interface M1User {
  code: string;        // e.g. M1-12-001
  name: string;
  phone: string;
  email: string;
  level: M1Level;
  levelLabel: string;
  location: "KR" | "VN";
  department: string;
  position: string;
  password: string;
  createdAt: string;
  status: "active" | "inactive";
}

export interface M2User {
  code: string;        // e.g. M2025-01-0001
  name: string;
  phone: string;
  email: string;
  loginKey: string;   // phone + first 3 letters of name
  registeredAt: string;
  company: string;
  industry: string;
  city: string;
  status: "active" | "pending" | "inactive";
  premium: boolean;
}

export const m1Users: M1User[] = [
  // Korean HQ
  {
    code: "M1-0",
    name: "Kim Donghyun",
    phone: "+82-10-1234-5678",
    email: "donghyun.kim@bizwell.kr",
    level: "M1-0",
    levelLabel: "Korean HQ Operator",
    location: "KR",
    department: "Operations",
    position: "CEO",
    password: "admin1234",
    createdAt: "2024-01-15",
    status: "active",
  },
  {
    code: "M1-01-001",
    name: "Lee Jinhyuk",
    phone: "+82-10-2345-6789",
    email: "jinhyuk.lee@bizwell.kr",
    level: "M1-01",
    levelLabel: "Korean Admin",
    location: "KR",
    department: "Sales",
    position: "Senior Manager",
    password: "admin1234",
    createdAt: "2024-02-01",
    status: "active",
  },
  {
    code: "M1-01-002",
    name: "Park Sooyeon",
    phone: "+82-10-3456-7890",
    email: "sooyeon.park@bizwell.kr",
    level: "M1-01",
    levelLabel: "Korean Admin",
    location: "KR",
    department: "Marketing",
    position: "Manager",
    password: "admin1234",
    createdAt: "2024-02-10",
    status: "active",
  },
  {
    code: "M1-02-001",
    name: "Choi Minjun",
    phone: "+82-10-4567-8901",
    email: "minjun.choi@bizwell.kr",
    level: "M1-02",
    levelLabel: "Korean Admin Lv2",
    location: "KR",
    department: "Tech",
    position: "Team Leader",
    password: "admin1234",
    createdAt: "2024-03-05",
    status: "active",
  },
  {
    code: "M1-02-002",
    name: "Jung Hyewon",
    phone: "+82-10-5678-9012",
    email: "hyewon.jung@bizwell.kr",
    level: "M1-02",
    levelLabel: "Korean Admin Lv2",
    location: "KR",
    department: "Business Dev",
    position: "Team Leader",
    password: "admin1234",
    createdAt: "2024-03-20",
    status: "active",
  },
  // Vietnam HQ
  {
    code: "M1-1",
    name: "Nguyen Van Thanh",
    phone: "+84-90-1234-567",
    email: "vanthanh.nguyen@bizwell.vn",
    level: "M1-1",
    levelLabel: "Vietnam HQ (Bizwell VN)",
    location: "VN",
    department: "Operations",
    position: "Country Director",
    password: "admin1234",
    createdAt: "2024-01-20",
    status: "active",
  },
  {
    code: "M1-11-001",
    name: "Tran Thi Mai",
    phone: "+84-91-2345-678",
    email: "thmai.tran@bizwell.vn",
    level: "M1-11",
    levelLabel: "Vietnam Admin",
    location: "VN",
    department: "Sales",
    position: "Senior Manager",
    password: "admin1234",
    createdAt: "2024-02-15",
    status: "active",
  },
  {
    code: "M1-11-002",
    name: "Le Quoc Hung",
    phone: "+84-93-3456-789",
    email: "quochung.le@bizwell.vn",
    level: "M1-11",
    levelLabel: "Vietnam Admin",
    location: "VN",
    department: "Marketing",
    position: "Manager",
    password: "admin1234",
    createdAt: "2024-03-01",
    status: "active",
  },
  {
    code: "M1-12-001",
    name: "Pham Thu",
    phone: "+84-94-4567-890",
    email: "thu.pham@bizwell.vn",
    level: "M1-12",
    levelLabel: "Vietnam Admin Lv2",
    location: "VN",
    department: "Customer Relations",
    position: "Team Leader",
    password: "admin1234",
    createdAt: "2024-03-15",
    status: "active",
  },
  {
    code: "M1-12-002",
    name: "Hoang Minh Duc",
    phone: "+84-97-5678-901",
    email: "minhduc.hoang@bizwell.vn",
    level: "M1-12",
    levelLabel: "Vietnam Admin Lv2",
    location: "VN",
    department: "Tech Support",
    position: "Team Leader",
    password: "admin1234",
    createdAt: "2024-04-01",
    status: "active",
  },
  {
    code: "M1-12-003",
    name: "Vo Thi Lan",
    phone: "+84-98-6789-012",
    email: "thilan.vo@bizwell.vn",
    level: "M1-12",
    levelLabel: "Vietnam Admin Lv2",
    location: "VN",
    department: "Business Dev",
    position: "Staff",
    password: "admin1234",
    createdAt: "2024-04-10",
    status: "active",
  },
  {
    code: "M1-12-004",
    name: "Nguyen Thi Bich",
    phone: "+84-96-7890-123",
    email: "thibich.nguyen@bizwell.vn",
    level: "M1-12",
    levelLabel: "Vietnam Admin Lv2",
    location: "VN",
    department: "Sales",
    position: "Staff",
    password: "admin1234",
    createdAt: "2024-05-01",
    status: "inactive",
  },
];

export const m2Users: M2User[] = [
  {
    code: "M2025-01-0001",
    name: "Nguyen Van An",
    phone: "0938085313",
    email: "vanan@gmail.com",
    loginKey: "0938085313van",
    registeredAt: "2025-01-05",
    company: "Cong ty TNHH An Phat",
    industry: "Sản xuất",
    city: "Ho Chi Minh",
    status: "active",
    premium: false,
  },
  {
    code: "M2025-01-0002",
    name: "Tran Thi Bich",
    phone: "0912345678",
    email: "thibich.tran@yahoo.com",
    loginKey: "0912345678thi",
    registeredAt: "2025-01-08",
    company: "CTY CP Bich Phat",
    industry: "Thương mại",
    city: "Ha Noi",
    status: "active",
    premium: true,
  },
  {
    code: "M2025-01-0003",
    name: "Le Minh Cuong",
    phone: "0908765432",
    email: "minhcuong.le@business.vn",
    loginKey: "0908765432min",
    registeredAt: "2025-01-12",
    company: "Cuong Tech VN",
    industry: "Công nghệ",
    city: "Da Nang",
    status: "active",
    premium: false,
  },
  {
    code: "M2025-02-0001",
    name: "Pham Thi Dung",
    phone: "0987654321",
    email: "thidung.pham@corp.vn",
    loginKey: "0987654321thi",
    registeredAt: "2025-02-03",
    company: "Dung Phat Trading",
    industry: "Xuất nhập khẩu",
    city: "Ho Chi Minh",
    status: "active",
    premium: true,
  },
  {
    code: "M2025-02-0002",
    name: "Hoang Van Ementor",
    phone: "0976543210",
    email: "ementor.hoang@vn.com",
    loginKey: "0976543210eme",
    registeredAt: "2025-02-10",
    company: "Ementor Group",
    industry: "Giáo dục",
    city: "Ha Noi",
    status: "pending",
    premium: false,
  },
  {
    code: "M2025-02-0003",
    name: "Nguyen Quoc Phong",
    phone: "0965432109",
    email: "quocphong@viettech.com",
    loginKey: "0965432109qua",
    registeredAt: "2025-02-18",
    company: "VietTech Solutions",
    industry: "Công nghệ",
    city: "Ho Chi Minh",
    status: "active",
    premium: false,
  },
  {
    code: "M2025-03-0001",
    name: "Do Thi Giang",
    phone: "0954321098",
    email: "thigiang.do@manufacturing.vn",
    loginKey: "0954321098thi",
    registeredAt: "2025-03-02",
    company: "Giang Long Manufacturing",
    industry: "Sản xuất",
    city: "Binh Duong",
    status: "active",
    premium: true,
  },
  {
    code: "M2025-03-0002",
    name: "Vu Minh Hai",
    phone: "0943210987",
    email: "minhhai.vu@logistic.vn",
    loginKey: "0943210987min",
    registeredAt: "2025-03-07",
    company: "Hai Minh Logistics",
    industry: "Vận tải",
    city: "Hai Phong",
    status: "active",
    premium: false,
  },
  {
    code: "M2025-03-0003",
    name: "Bui Thi Lan",
    phone: "0932109876",
    email: "thilan.bui@interior.vn",
    loginKey: "0932109876thi",
    registeredAt: "2025-03-15",
    company: "Lan Interior Design",
    industry: "Nội thất",
    city: "Da Nang",
    status: "active",
    premium: false,
  },
  {
    code: "M2025-03-0004",
    name: "Dang Van Khoa",
    phone: "0921098765",
    email: "vankhoa.dang@medical.vn",
    loginKey: "0921098765van",
    registeredAt: "2025-03-22",
    company: "Khoa Medical Supplies",
    industry: "Y tế",
    city: "Ho Chi Minh",
    status: "pending",
    premium: false,
  },
  {
    code: "M2025-03-0005",
    name: "Phan Minh Long",
    phone: "0910987654",
    email: "minhlong.phan@energy.vn",
    loginKey: "0910987654min",
    registeredAt: "2025-03-28",
    company: "Long Energy Co.",
    industry: "Năng lượng",
    city: "Can Tho",
    status: "active",
    premium: true,
  },
];

export const generateM2Code = (phone: string, name: string): string => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const seq = String(m2Users.filter((u) => u.code.startsWith(`M${year}-${month}`)).length + 1).padStart(4, "0");
  return `M${year}-${month}-${seq}`;
};

export const generateLoginKey = (phone: string, name: string): string => {
  const nameParts = name.trim().split(" ");
  const lastName = nameParts[nameParts.length - 1];
  const suffix = lastName.substring(0, 3).toLowerCase();
  return `${phone}${suffix}`;
};

export const m1LevelLabels: Record<string, string> = {
  "M1-0": "Korean HQ Operator",
  "M1-1": "Vietnam HQ (Bizwell VN)",
  "M1-01": "Korean Admin Lv1",
  "M1-11": "Vietnam Admin Lv1",
  "M1-02": "Korean Admin Lv2",
  "M1-12": "Vietnam Admin Lv2",
};

export const m1HierarchyOrder = ["M1-0", "M1-1", "M1-01", "M1-11", "M1-02", "M1-12"];
